export default __webpack_public_path__ + "static/media/On-site Registration.7ae15d05.JPG";